<template>
  <section class="su-skills">
    <div class="su-title">
      <p>о школе</p>
      <h2>
        <span>полноценная замена обычной школы</span>
        с&nbsp;обучением востребованным навыкам
        и&nbsp;профессиям для&nbsp;будущего вашего ребенка
      </h2>
    </div>

    <custom-scroll-slider
      :items="classes"
      class="su-skills__btns"
      :container-width="null"
      :gap="null"
    >
      <template #item="{ slide: btn }">
        <button
          :class="['m-btn su-skills__btn', { 'su-skills__btn--active': activeClassId === btn.id }]"
          :style="`--hover-color: ${btn.hoverColor}; --active-color: ${btn.activeColor}`"
          @click="activeClassId = btn.id"
        >
          {{ btn.title }}
        </button>
      </template>
    </custom-scroll-slider>

    <su-skills-block
      :block="currentBlock"
      @openModal="openModal"
    />
  </section>
</template>

<script>
import CustomScrollSlider from '../../common/CustomScrollSlider.vue';
import SuSkillsBlock from './SuSkillsBlock.vue';

export default {
  name: 'SuSkills',
  components: { SuSkillsBlock, CustomScrollSlider },
  data: () => ({
    activeClassId: 1,
    classes: [
      {
        id: 1,
        title: 'просто класс',
        activeColor: '#5237E6',
        hoverColor: '#846EFB',
        modalType: 'simple',
      },
      {
        id: 2,
        title: 'it класс',
        activeColor: '#0A4183',
        hoverColor: '#0B72BE',
        modalType: 'it',
      },
      {
        id: 3,
        title: 'кибер класс',
        activeColor: '#045140',
        hoverColor: '#00C2B9',
        modalType: 'cyber',
      },
      {
        id: 4,
        title: 'бизнес класс',
        activeColor: '#02120F',
        hoverColor: '#5B5B5B',
        modalType: 'business',
      },
      {
        id: 5,
        title: 'digital класс',
        activeColor: '#FF5319',
        hoverColor: '#FF9C12',
        modalType: 'digital',
      },
      {
        id: 6,
        title: 'медиа класс',
        activeColor: '#006440',
        hoverColor: '#22AE73',
        modalType: 'media',
      },
      {
        id: 7,
        title: 'мед. класс',
        activeColor: '#8D176C',
        hoverColor: '#F199CE',
        modalType: 'medical',
      },
    ],
  }),
  computed: {
    currentBlock() {
      return this.classes.find((block) => block.id === this.activeClassId) || this.classes[0];
    },
  },
  mounted() {
    if (this.$route.query.class) {
      const routeClassId = Number(this.$route.query.class);
      this.activeClassId = Number.isNaN(routeClassId) ? 1 : routeClassId;
    }
  },
  methods: {
    openModal() {
      this.$emit('openModal', this.currentBlock?.modalType);
    },
  },
};
</script>

<style scoped lang="scss">
$size-tablet: 1200px;

.su-skills {
  .su-title {
    h2 {
      @include media-down($size-tablet) {
        font-size: 4rem;
        text-indent: 0 !important;
      }

      span {
        color: #5237E6 !important;
      }
    }

    p {
      @include media-down($size-tablet) {
        position: relative;
        top: 0;
        margin-bottom: -2px;
      }
    }
  }

  .su-skills__btns {
    width: calc(100% + var(--padInline) * 2);
    margin-left: calc(-1 * var(--padInline));
    margin-top: 2.5rem;
    margin-bottom: calc(var(--scale) * 30);
    padding-inline: var(--padInline) !important;

    display: flex;
    gap: 0.5rem;

    @include media-down($size-tablet) {
      margin-bottom: 1.6rem;
      gap: 0.4rem;
    }
  }

  .su-skills__btn {
    padding: 2rem 3.375rem;
    background-color: #FFFFFF;
    border-radius: 200px;
    transition: 300ms;

    white-space: nowrap;
    font-weight: 500;
    font-size: 2rem;
    line-height: 110%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      padding: 1.6rem 2.2rem;
      font-size: 1.8rem;
    }

    &--active {
      background-color: var(--active-color);
      color: #FFFFFF;
    }

    @media (hover: hover) {
      &:hover {
        background-color: var(--hover-color);
        color: #FFFFFF;
      }
    }
  }
}

</style>
